import { FC, useState, useEffect } from 'react'

import {
  Button,
  CheckBox,
  Col,
  Row,
  SelectForm,
  Span,
  TimePicker
} from 'components'
import moment from 'moment'
import { COLORS, SPACING } from 'utils'

import { IPeriocidadeComponent } from '../Diario/Diario'

const Semanal: FC<IPeriocidadeComponent> = ({
  control,
  periodicidade,
  listOptions,
  setValue,
  setHasErrorJob,
  jobRecorrenciasList,
  jobDiasSemanaRecorrencia,
  isConsult
}) => {
  const fixWeekDays = [
    { label: 'Segunda-feira', selected: false, toSend: 'Monday' },
    { label: 'Terça-feira', selected: false, toSend: 'Tuesday' },
    { label: 'Quarta-feira', selected: false, toSend: 'Wednesday' },
    { label: 'Quinta-feira', selected: false, toSend: 'Thursday' },
    { label: 'Sexta-feira', selected: false, toSend: 'Friday' },
    { label: 'Sábado', selected: false, toSend: 'Saturday' },
    { label: 'Domingo', selected: false, toSend: 'Sunday' }
  ]
  const [errorsJobs, setErrorsJobs] = useState({ horarioError: null })
  const [errorWeek, setErrorWeek] = useState('')
  const [weekDays, setWeekDays] = useState<any[]>(fixWeekDays)

  // LISTA HORARIO DO COMPONENTE
  const [listDiario, setListDiario] = useState([
    {
      hrRecorrencia: '',
      id: 0
    }
  ])

  // NOVA LINHA DE HORARIO
  const handleNewItem = () => {
    setListDiario([
      ...listDiario,
      { hrRecorrencia: '', id: listDiario[listDiario.length - 1].id + 1 }
    ])
  }

  // UPDATE DO HORARIO NA LISTA HORARIO
  const handleTimePicker = (time, index) => {
    if (time) {
      const cpyArr = listDiario.slice()
      cpyArr[index].hrRecorrencia = time
      setListDiario(cpyArr)
      setValue('semanal', cpyArr)
      setValue('horario', time)
    }
  }

  // UPDATE DIAS DA SEMANA SELECIONADO
  const handleWeekDay = (index) => {
    const cpyArr = weekDays.slice()
    cpyArr[index].selected = !cpyArr[index].selected
    setWeekDays(cpyArr)
    setValue('diasSemana', cpyArr)
  }

  // DELETAR HORARIO ADICIONADO
  const handleDelete = (id: number) => {
    const cpyArr = listDiario.slice()
    setListDiario(cpyArr.filter((hr) => hr.id !== id))
    setValue(
      'semanal',
      cpyArr.filter((hr) => hr.id !== id)
    )
  }

  const handleClean = () => {
    setListDiario([{ hrRecorrencia: '', id: 0 }])
    setWeekDays(fixWeekDays)
    setValue('diasSemana', [])
    setValue('semanal', [{ hrRecorrencia: null, id: 0 }])
  }

  // ENVIO DOS DADOS DO COMPONENTE PARA MODAL

  useEffect(() => {
    if (!weekDays || weekDays.length == 0) {
      setWeekDays(fixWeekDays)
    }

    if (jobRecorrenciasList.length == 0) {
      setListDiario([
        {
          hrRecorrencia: '',
          id: 0
        }
      ])
    } else {
      setListDiario(jobRecorrenciasList)
      setValue('semanal', jobRecorrenciasList)
    }

    const tempArray = jobDiasSemanaRecorrencia?.split(',')
    tempArray?.forEach((day) => {
      const locIndex = weekDays.findIndex((weekday) => weekday.toSend === day)
      if (locIndex !== -1) {
        weekDays[locIndex].selected = true
      }
    })
  }, [])

  useEffect(() => {
    const tempVar = listDiario.filter(
      (item) => item.hrRecorrencia !== '' && item.hrRecorrencia !== null
    )

    if (tempVar.length > 0) {
      setErrorsJobs((old) => ({
        ...old,
        horarioError: null
      }))
      setHasErrorJob((old) => ({
        ...old,
        horarioError: false
      }))
    } else {
      setErrorsJobs((old) => ({
        ...old,
        horarioError: {
          message: 'Ao menos um horário deve ser informado'
        }
      }))
      setHasErrorJob((old) => ({
        ...old,
        horarioError: true
      }))
    }
  }, [listDiario])

  useEffect(() => {
    const locIndex = weekDays.findIndex((weekday) => weekday.selected)
    if (locIndex === -1) {
      setErrorWeek('Selecione ao menos um dia da semana!')
      setHasErrorJob((old) => ({
        ...old,
        semanaError: true
      }))
    } else {
      setErrorWeek('')
      setHasErrorJob((old) => ({
        ...old,
        semanaError: false
      }))
    }
    if (!weekDays || weekDays.length == 0) {
      setWeekDays(fixWeekDays)
    }
  }, [weekDays])

  return (
    <Col>
      <Row justifyContent="start">
        <Col>
          <SelectForm
            defaultValue={periodicidade}
            control={control}
            listOptions={listOptions}
            label="Tipo"
            width="160px"
            formValue="tipo"
            disabled={isConsult}
          />
        </Col>
        <Col marginLeft={SPACING.spacing15}>
          {listDiario.map((diario, index) => (
            <Col key={index} marginBottom={SPACING.spacing10}>
              <Row alignItems="center" justifyContent="start">
                <TimePicker
                  marginRight={SPACING.spacing20}
                  label="Horário"
                  customError={errorsJobs.horarioError}
                  value={
                    diario.hrRecorrencia
                      ? moment(diario.hrRecorrencia).toDate()
                      : null
                  }
                  onChange={(data) => handleTimePicker(data, index)}
                  allowTyping={true}
                  disabled={isConsult}
                />

                {listDiario.length - 1 === index ? (
                  <Button
                    text="+"
                    onClick={handleNewItem}
                    disabled={isConsult}
                  />
                ) : (
                  <Button
                    text="-"
                    onClick={() => handleDelete(diario.id)}
                    disabled={isConsult}
                  />
                )}
              </Row>
            </Col>
          ))}
        </Col>
      </Row>
      <Row
        alignItems="center"
        justifyContent="start"
        marginTop={SPACING.spacing20}
      >
        {weekDays.map((day, index) => (
          <CheckBox
            key={index}
            label={day.label}
            checked={day.selected}
            onChange={() => handleWeekDay(index)}
            disabled={isConsult}
          />
        ))}
      </Row>
      <Span
        marginLeft={SPACING.spacing20}
        text={errorWeek}
        color={COLORS.error}
      />
      <Row alignItems="center" justifyContent="end">
        <Button
          text="Limpar"
          onClick={handleClean}
          variantButton="text"
          disabled={isConsult}
        />
      </Row>
    </Col>
  )
}
export default Semanal
